(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    const getVisibleThumbs = (nav) => {
    const buttons = Array.from(nav.querySelectorAll('button.product-gallery__thumbnail'));

    return buttons.filter((btn) => {
      if (btn.hasAttribute('hidden')) return false;

      const style = window.getComputedStyle(btn);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  };

  const getCurrentIndex = (thumbs) => {
    const index = thumbs.findIndex((btn) => btn.getAttribute('aria-current') === 'true');
    return index >= 0 ? index : 0;
  };

  const moveThumb = (nav, dir) => {
    const thumbs = getVisibleThumbs(nav);
    if (thumbs.length === 0) return;

    const currentIndex = getCurrentIndex(thumbs);
    const delta = dir === 'next' ? 1 : -1;
    const nextIndex = (currentIndex + delta + thumbs.length) % thumbs.length;

    const nextThumb = thumbs[nextIndex];
    nextThumb.click();
    nextThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('button[data-thumb-arrow]');
    if (!arrow) return;

    const dir = arrow.dataset.thumbArrow;
    if (dir !== 'prev' && dir !== 'next') return;

    const gallery = arrow.closest('product-gallery');
    if (!gallery) return;

    const nav = gallery.querySelector('product-gallery-navigation.product-gallery__thumbnail-scroller');
    if (!nav) return;

    event.preventDefault();
    moveThumb(nav, dir);
  });
  } catch(e) { console.error(e); }
})();

})();
